import React, { useEffect, useState, useContext } from "react";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Typography,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import "./Risk.css";
import { api, get, post, put } from "../../../utils/api";
import { companyId } from "../../../utils/companyId";
import { textError } from "../../../utils/validationMessage";
import ActionButtons from "../InitialKickoff/MaterialTopics/ActionButtons";
import { ProgressContext } from "../ContextAPI";
import SkipQuestionare from "../../Common/SkipQuestionare";
import InitialQuestionareSidebar from "../../../Layout/InitialQuestionareSidebar";
import { getQuestionareSubmitted } from "../../../utils/storage";

const Stakeholder = () => {
  const companyDetails = getQuestionareSubmitted();

  const { setUpdate } = useContext(ProgressContext);
  const navigate = useNavigate();
  const [isExist, setisExist] = useState(false);
  const [DeleteIndex, setIndexDelete] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFromData] = useState({
    companyId: companyId,
    stakeholderIdentificationEngagementProcesses: {
      radio: "yes",
      Scope: "",
    },
    indentificationMitigationEsgRisk: {
      esg_risk: [""],
      mitigation: [""],
    },
  });
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const {
      stakeholderIdentificationEngagementProcesses,
      indentificationMitigationEsgRisk,
    } = formData;

    // Validate `stakeholderIdentificationEngagementProcesses`
    if (
      (!stakeholderIdentificationEngagementProcesses.Scope &&
        formData.stakeholderIdentificationEngagementProcesses.radio ===
          "yes") ||
      (stakeholderIdentificationEngagementProcesses.Scope.trim() === "" &&
        formData.stakeholderIdentificationEngagementProcesses.radio === "yes")
    ) {
      newErrors.stakeholderIdentificationEngagementProcessesScope = textError;
    }

    // Validate `indentificationMitigationEsgRisk`
    indentificationMitigationEsgRisk.esg_risk.forEach((risk, index) => {
      if (index > 0 || (index === 0 && risk.trim() !== "")) {
        if (!risk || risk.trim() === "") {
          newErrors[`indentificationMitigationEsgRiskEsgRisk${index}`] =
            textError;
        }
      }
    });

    indentificationMitigationEsgRisk.mitigation.forEach((mitigation, index) => {
      if (index > 0 || (index === 0 && mitigation.trim() !== "")) {
        if (!mitigation || mitigation.trim() === "") {
          newErrors[`indentificationMitigationEsgRiskMitigation${index}`] =
            textError;
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleStakeholder = (e) => {
    const { name, value } = e.target;
    setFromData({
      ...formData,
      stakeholderIdentificationEngagementProcesses: {
        ...formData.stakeholderIdentificationEngagementProcesses,
        [name]: value,
      },
    });
  };
  const handleIndentification = (e, index, fieldType) => {
    const { name, value } = e.target;
    //  setFromData({
    //   ...formData,
    //     indentificationMitigationEsgRisk:{
    //    ...formData.indentificationMitigationEsgRisk,
    //    [name]:value
    //  }
    // })
    const updatedCommittees = { ...formData.indentificationMitigationEsgRisk };
    updatedCommittees[fieldType][index] = value;
    setFromData({
      ...formData,
      indentificationMitigationEsgRisk: updatedCommittees,
    });
  };
  console.log(formData);
  const handleRemoveField = (index) => {
    setOpenDialog(true);
    // setFieldToRemove({ fieldName, index });
    setIndexDelete(index);
  };
  const confirmRemoveField = () => {
    console.log("fieldToRemove", DeleteIndex);
    const updatedCommittees = { ...formData.indentificationMitigationEsgRisk };
    if (updatedCommittees.esg_risk.length > DeleteIndex) {
      // Remove the element at the specific index from both esg_risk and mitigation arrays
      updatedCommittees.esg_risk.splice(DeleteIndex, 1);
    }
    if (updatedCommittees.mitigation.length > DeleteIndex) {
      updatedCommittees.mitigation.splice(DeleteIndex, 1);
    }
    console.log(updatedCommittees, "updatedCommittees");
    setFromData({
      ...formData,
      indentificationMitigationEsgRisk: updatedCommittees,
    });
    setOpenDialog(false);
  };

  const cancelRemoveField = () => {
    setOpenDialog(false);
  };
  useEffect(() => {
    setUpdate("GOVERNANCE");
    get(`${api}/governance/stakeholder-engagement`)
      .then((res) => {
        console.log(res.data);
        setFromData({
          stakeholderIdentificationEngagementProcesses: {
            radio:
              res.data.stakeholderIdentificationEngagementProcesses.radio ===
              true
                ? "yes"
                : "no",
            Scope: res.data.stakeholderIdentificationEngagementProcesses.Scope,
          },
          indentificationMitigationEsgRisk: {
            esg_risk: res.data.indentificationMitigationEsgRisk.esg_risk,
            mitigation: res.data.indentificationMitigationEsgRisk.mitigation,
          },
        });
        setisExist(true);
      })
      .catch((err) => console.log(err));
  }, []);
  const AddTextfieldIndentification = (e) => {
    const { name, value } = e.target;
    const updatedCommittees = { ...formData.indentificationMitigationEsgRisk };
    updatedCommittees.esg_risk.push("");
    updatedCommittees.mitigation.push("");

    setFromData({
      ...formData,
      indentificationMitigationEsgRisk: updatedCommittees,
    });
  };
  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    const {
      stakeholderIdentificationEngagementProcesses,
      indentificationMitigationEsgRisk,
    } = formData;

    const isNonEmptyArray = (arr) => Array.isArray(arr) && arr.length > 0;
    const isNonEmptyString = (str) =>
      typeof str === "string" && str.trim().length > 0;

    // Validation check for stakeholder field
    const stakeholder =
      isNonEmptyString(stakeholderIdentificationEngagementProcesses?.radio) &&
      (isNonEmptyString(stakeholderIdentificationEngagementProcesses?.Scope) ||
        isNonEmptyArray(indentificationMitigationEsgRisk?.esg_risk) ||
        isNonEmptyArray(indentificationMitigationEsgRisk?.mitigation));

    const payload = {
      ...formData,
      stakeholder,
    };
    let method = isExist ? put : post;
    let url = `/governance/stakeholder-engagement`;
    await method(url, payload)
      .then((res) => {
        navigate(
          companyDetails?.questionareSubmitted
            ? "/preview"
            : "/governance/cybersecurity"
        );
      })
      .catch((err) => {
        console.log(err);
      });
    //
  };

  const Back = () => {
    navigate("/governance/risk-management");
  };

  return (
    <Box
      display="flex"
      sx={{
        backgroundColor: "#EDEDED",
        display: "flex",
        height: "100vh",
      }}
    >
      <Dialog open={openDialog} onClose={cancelRemoveField}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this field?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelRemoveField} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmRemoveField} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
      <Box
        sx={{
          width: "25vw",
          // overflowY: "auto",
        }}
      >
        <InitialQuestionareSidebar />
      </Box>
      <Box
        width="100%"
        sx={{
          p: 2,
          mt: 3,
          width: "75vw",
          height: "100vh", // Full viewport height
          overflowY: "auto", // Allow vertical scrolling if content exceeds viewport
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start", // Adjust to start at the top of the box
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "1rem",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: "bold",
              zIndex: 1,
              padding: "10px 0px",
              borderRadius: "4px",
              alignSelf: "flex-start",
            }}
          >
            GOVERNANCE: STAKEHOLDER ENGAGEMENT
          </Typography>
          <SkipQuestionare />
        </div>

        <Box
          display="flex"
          flexDirection="column"
          gap={2}
          className="main"
          sx={{ width: "80%" }}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mb: "-1rem", mt: 2 }}
            className="heading"
          >
            Stakeholder Identification and Engagement Processes
          </Typography>
          <RadioGroup
            row
            name="radio"
            value={formData.stakeholderIdentificationEngagementProcesses.radio}
            onChange={handleStakeholder}
          >
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>

          {formData.stakeholderIdentificationEngagementProcesses.radio ===
          "yes" ? (
            <Box>
              <TextField
                variant="outlined"
                placeholder="Scope..."
                // className="brief"
                name="Scope"
                value={
                  formData.stakeholderIdentificationEngagementProcesses.Scope
                }
                onChange={(e) => {
                  handleStakeholder(e);
                  setErrors({
                    ...errors,
                    stakeholderIdentificationEngagementProcessesScope: "",
                  });
                }}
                multiline
                rows={3}
                // sx={{ mb: 3, width: '90%' }}
                InputProps={{
                  style: {
                    borderColor:
                      errors.stakeholderIdentificationEngagementProcessesScope
                        ? "#D34040"
                        : undefined,
                  },
                }}
                sx={{ width: "100%" }}
                error={
                  !!errors.stakeholderIdentificationEngagementProcessesScope
                } // Show error styling if there's an error
                InputLabelProps={{
                  style: {
                    color:
                      errors.stakeholderIdentificationEngagementProcessesScope
                        ? "#D34040"
                        : undefined,
                  },
                }}
              />
              {errors.stakeholderIdentificationEngagementProcessesScope && (
                <Typography variant="body2" color="#D34040">
                  {errors.stakeholderIdentificationEngagementProcessesScope}
                </Typography>
              )}
            </Box>
          ) : (
            ""
          )}

          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", marginBottom: "-0.7rem", mt: 1 }}
            className="heading"
          >
            Identification and Mitigation of ESG Risks
          </Typography>

          {formData.indentificationMitigationEsgRisk.esg_risk.map((item, i) => {
            return (
              <Box key={i} sx={{ width: "110%", display: "flex", gap: 1 }}>
                <Grid container sx={{ width: "100%" }}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      variant="outlined"
                      placeholder="Description of ESG Risk"
                      // className="riskText"
                      name="esg_risk"
                      value={item}
                      onChange={(e) => {
                        handleIndentification(e, i, "esg_risk");
                        setErrors({
                          ...errors,
                          [`indentificationMitigationEsgRiskEsgRisk${i}`]: "",
                        });
                      }}
                      multiline
                      rows={3}
                      fullWidth
                      InputProps={{
                        style: {
                          borderColor: errors[
                            `indentificationMitigationEsgRiskEsgRisk${i}`
                          ]
                            ? "#D34040"
                            : undefined,
                        },
                      }}
                      sx={{ width: "100%" }}
                      error={
                        !!errors[`indentificationMitigationEsgRiskEsgRisk${i}`]
                      } // Show error styling if there's an error
                      InputLabelProps={{
                        style: {
                          color: errors[
                            `indentificationMitigationEsgRiskEsgRisk${i}`
                          ]
                            ? "#D34040"
                            : undefined,
                        },
                      }}
                    />
                    {errors[`indentificationMitigationEsgRiskEsgRisk${i}`] && (
                      <Typography variant="body2" color="#D34040">
                        {errors[`indentificationMitigationEsgRiskEsgRisk${i}`]}
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box display="flex">
                      <TextField
                        variant="outlined"
                        placeholder="Mitigation"
                        // className="riskText"

                        name="mitigation"
                        value={
                          formData.indentificationMitigationEsgRisk.mitigation[
                            i
                          ]
                        }
                        onChange={(e) => {
                          handleIndentification(e, i, "mitigation");
                          setErrors({
                            ...errors,
                            [`indentificationMitigationEsgRiskMitigation${i}`]:
                              "",
                          });
                        }}
                        multiline
                        rows={3}
                        fullWidth
                        InputProps={{
                          style: {
                            borderColor: errors[
                              `indentificationMitigationEsgRiskMitigation${i}`
                            ]
                              ? "#D34040"
                              : undefined,
                          },
                        }}
                        sx={{ width: "100%", marginLeft: "1rem" }}
                        error={
                          !!errors[
                            `indentificationMitigationEsgRiskMitigation${i}`
                          ]
                        } // Show error styling if there's an error
                        InputLabelProps={{
                          style: {
                            color: errors[
                              `indentificationMitigationEsgRiskMitigation${i}`
                            ]
                              ? "#D34040"
                              : undefined,
                          },
                        }}
                      />
                    </Box>
                    {errors[
                      `indentificationMitigationEsgRiskMitigation${i}`
                    ] && (
                      <Typography
                        variant="body2"
                        color="#D34040"
                        style={{ marginLeft: "1rem" }}
                      >
                        {
                          errors[
                            `indentificationMitigationEsgRiskMitigation${i}`
                          ]
                        }
                      </Typography>
                    )}
                  </Grid>
                </Grid>
                <Box sx={{ width: "9%" }}>
                  {i > 0 && (
                    <IconButton sx={{ mt: 0, width: "5%" }}>
                      <DeleteIcon onClick={() => handleRemoveField(i)} />
                    </IconButton>
                  )}
                </Box>
              </Box>
            );
          })}

          <Grid
            item
            xs={12}
            display="flex"
            sx={{ width: "100%" }}
            justifyContent="flex-end"
          >
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              sx={{
                alignSelf: "flex-end",
                color: "#74757E",
                borderColor: "#74757E",
                display: "flex",
                justifyContent: "flex-end",
                "&:hover": {
                  backgroundColor: "rgba(25, 118, 210, 0.04)",
                  color: "#115293",
                  borderColor: "#115293",
                },
              }}
              className="add"
              onClick={AddTextfieldIndentification}
              disabled={
                formData.indentificationMitigationEsgRisk.mitigation[0].trim() ===
                  "" ||
                formData.indentificationMitigationEsgRisk.esg_risk[0].trim() ===
                  ""
              }
            >
              Add
            </Button>
          </Grid>
          {/* </Grid> */}
          <div style={{ width: "100%" }}>
            <ActionButtons
              Back={Back}
              Move={Save}
              disable={companyDetails?.questionareSubmitted}
            />
          </div>
        </Box>
      </Box>
    </Box>
  );
};

export default Stakeholder;
